import { getRequest, postRequest } from "app/axiosClient";
import { getAttachments } from "./AttachmentsSlice";
import {
  showLoader,
  hideLoader,
} from "../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "common/utils/OpenNotificationWithIcon";
export const getAttachmentsList = (appointmentId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(
      `api/Attachments/GetAttachmentsList?appointmentId=${appointmentId}`
    )
      .then((res) => {
        dispatch(getAttachments(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        // dispatch(
        //   showNotification({
        //     show: true,
        //     messageId: "Visits.Unablefetchdata",
        //     type: "error",
        //   })
        // );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Visits.Unablefetchdata"
    );
  }
};

export const uploadImages =
  (input, appointmentid, setSaveDisable) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(`api/Attachments/UploadAttachments`, input)
        .then((res) => {
          dispatch(hideLoader());
          dispatch(getAttachmentsList(appointmentid));
          setSaveDisable(true);
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Attachment.ImageUploadSuccess"
          );
        })
        .catch((e) => {
          dispatch(hideLoader());
          // dispatch(
          //   showNotification({
          //     show: true,
          //     messageId: "Attachment.UnableToDownload",
          //     type: "error",
          //   })
          // );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Attachment.UnableToDownload"
      );
    }
  };

export const deleteImagesApi = (input) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Attachments/DeleteAttachments`, input)
      .then((res) => {
        dispatch(hideLoader());
        dispatch(getAttachmentsList(input?.noteId));
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Attachment.ImageDeleteSuccess"
        );
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Attachment.UnableToDelete"
    );
  }
};
